import Categories from 'views/store/articles/Categories';
import Index from 'views/store/articles/Index';
import Ingredients from 'views/store/articles/Ingredients';
import Menus from 'views/store/articles/Menus';
import FloorPlans from 'views/store/in-house/FloorPlans';
import QrCodes from 'views/store/in-house/QrCodes';
import Settings from 'views/store/in-house/Settings';
import ArticleSettings from 'views/store/Settings';
import Promotions from 'views/store/Promotions';
import GuestBook from './views/store/GuestBook';
import Stations from 'views/store/articles/Stations';
import Users from 'views/store/articles/Users';
import ParkingStations from 'views/store/articles/ParkingStations';
import Tables from 'views/store/in-house/tables';
import Dashboard from 'views/store/dashboard/Dashboard';
import '../src/assets/css/tables-view.css'

var routes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    icon: '/img/sidebar/ic_dashboard.png',
    icon_active: '/img/white/ic_dashboard.png',
    component: Dashboard,
    layout: '/store'
  },
  {
    path: '/articles/articles',
    name: 'Articles',
    icon: '/img/sidebar/ic_articles.png',
    icon_active: '/img/white/ic_articles.png',
    layout: '/store',
    children: [
      {
        name: 'Articles',
        icon: '/img/sidebar/ic_articles.png',
        icon_active: '/img/sidebar/spoon-blue.png',
        component: Index,
        layout: '/store',
        type: 'header'
      },
      {
        path: '/articles/articles',
        name: 'Articles',
        icon: '/img/sidebar/spoon.png',
        icon_active: '/img/sidebar/spoon-blue.png',
        component: Index,
        layout: '/store'
      },
      {
        path: '/articles/ingredients',
        name: 'Ingredients',
        icon: '/img/sidebar/bowl.png',
        icon_active: '/img/sidebar/bowl-blue.png',
        component: Ingredients,
        layout: '/store'
      },
      {
        path: '/articles/categories',
        name: 'Categories',
        icon: '/img/sidebar/tag.png',
        icon_active: '/img/sidebar/tag-blue.png',
        component: Categories,
        layout: '/store'
      },
      {
        path: '/articles/menus',
        name: 'Menus',
        icon: '/img/sidebar/burger.png',
        icon_active: '/img/sidebar/burger-blue.png',
        component: Menus,
        layout: '/store'
      }
      // {
      //   path: '/articles/subgroups',
      //   name: 'Supergroups',
      //   icon: '/img/sidebar/object.png',
      //   icon_active: '/img/sidebar/object-blue.png',
      //   component: Subgroups,
      //   layout: '/store'
      // },
      // {
      //   path: '/articles/subgroups-articles',
      //   name: 'Supergroup Articles',
      //   icon: '/img/sidebar/object.png',
      //   icon_active: '/img/sidebar/object-blue.png',
      //   component: SubgroupsArticles,
      //   layout: '/store'
      // }
    ]
  },
  {
    path: '/kitchen/users',
    name: 'Kitchen',
    icon: '/img/sidebar/ic_kitchen.png',
    icon_active: '/img/white/ic_kitchen.png',
    layout: '/store',
    children: [
      {
        path: '/kitchen/users',
        name: 'Users',
        icon: '/img/sidebar/burger.png',
        icon_active: '/img/sidebar/burger-blue.png',
        component: Users,
        layout: '/store'
      },
      {
        path: '/kitchen/stations',
        name: 'Stations',
        icon: '/img/sidebar/burger.png',
        icon_active: '/img/sidebar/burger-blue.png',
        component: Stations,
        layout: '/store'
      },
      {
        path: '/kitchen/parking-stations',
        name: 'Parking stations',
        icon: '/img/sidebar/burger.png',
        icon_active: '/img/sidebar/burger-blue.png',
        component: ParkingStations,
        layout: '/store'
      }
    ]
  },
  {
    path: '/session/settings',
    name: 'Sessions',
    icon: '/img/sidebar/ic_session.png',
    icon_active: '/img/white/ic_session.png',
    component: FloorPlans,
    layout: '/store'
  },
  {
    path: '/in-store/settings',
    name: 'InStore',
    icon: '/img/sidebar/home.png',
    icon_active: '/img/white/home.png',
    select_icon: '/img/white/home.png',
    layout: '/store',
    children: [
      {
        name: 'InStore',
        icon: '/img/sidebar/home.png',
        icon_active: '/img/sidebar/home-blue.png',
        layout: '/store',
        type: 'header'
      },
      {
        path: '/in-store/settings',
        name: 'Settings',
        icon: '/img/sidebar/setting.png',
        icon_active: '/img/sidebar/setting-blue.png',
        component: Settings,
        layout: '/store'
      },
      // {
      //   path: '/in-store/reporting',
      //   name: 'Reporting',
      //   icon: '/img/sidebar/report.png',
      //   icon_active: '/img/sidebar/report-blue.png',
      //   component: Reporting,
      //   layout: '/store'
      // },
      {
        path: '/in-store/qr-codes',
        name: 'QR Codes',
        icon: '/img/sidebar/qr-code.png',
        icon_active: '/img/sidebar/qr-code-blue.png',
        component: QrCodes,
        layout: '/store'
      },
      {
        path: '/in-store/floor-plans',
        name: 'Floor plans',
        icon: '/img/sidebar/dining-table.png',
        icon_active: '/img/sidebar/dining-table-blue.png',
        component: Tables,
        layout: '/store'
      },
    ]
  },
  {
    path: '/takeaway-delivery/settings',
    name: 'Takeaway | Delivery',
    icon: '/img/sidebar/jar.png',
    icon_active: '/img/white/jar.png',
    select_icon: '/img/white/jar.png',
    layout: '/store',
    children: [
      {
        name: 'Takeaway | Delivery',
        icon: '/img/sidebar/jar.png',
        icon_active: '/img/sidebar/jar-blue.png',
        layout: '/store',
        type: 'header'
      },
      {
        path: '/takeaway-delivery/settings',
        name: 'Settings',
        icon: '/img/sidebar/setting.png',
        icon_active: '/img/white/setting-blue.png',
        component: Settings,
        layout: '/store'
      },

      // {
      //   path: '/takeaway-delivery/reporting',
      //   name: 'Reporting',
      //   icon: '/img/sidebar/report.png',
      //   icon_active: '/img/sidebar/report-blue.png',
      //   component: Reporting,
      //   layout: '/store'
      // },
      // {
      //   path: '/takeaway-delivery/postalCode',
      //   name: 'PostalCode',
      //   icon: '/img/sidebar/setting.png',
      //   icon_active: '/img/sidebar/setting-blue.png',
      //   component: PostalCode,
      //   layout: '/store'
      // },
      // {
      //   path: '/takeaway-delivery/orders',
      //   name: 'Orders',
      //   icon: '/img/sidebar/burger.png',
      //   icon_active: '/img/sidebar/burger-blue.png',
      //   component: Orders,
      //   layout: '/store'
      // },
      // {
      //   path: '/takeaway-delivery/marketing',
      //   name: 'Marketing',
      //   icon: '/img/sidebar/at_b.png',
      //   icon_active: '/img/sidebar/at-blue.png',
      //   component: Marketing,
      //   layout: '/store'
      // },
      {
        path: '/takeaway-delivery/qr-codes',
        name: 'QR Codes',
        icon: '/img/sidebar/qr-code.png',
        icon_active: '/img/sidebar/qr-code-blue.png',
        component: QrCodes,
        layout: '/store'
      },
      //   {
      //     path: "/takeaway-delivery/floor-plans",
      //     name: "Floor Plans",
      //     icon: "/img/sidebar/map.png",
      //     icon_active: "/img/sidebar/map-blue.png",
      //     component: FloorPlans,
      //     layout: "/store",
      //   },
      // {
      //   path: '/takeaway-delivery/guest-registration',
      //   name: 'Guest Registration',
      //   icon: '/img/sidebar/pen.png',
      //   icon_active: '/img/sidebar/pen-blue.png',
      //   component: GuestRegistration,
      //   layout: '/store'
      // },
      // {
      //   path: '/takeaway-delivery/limitedOrders',
      //   name: 'Limited Orders',
      //   icon: '/img/sidebar/speed.png',
      //   icon_active: '/img/sidebar/speed-blue.png',
      //   component: LimitedOrders,
      //   layout: '/store'
      // }
    ]
  },
  {
    path: '/promotions',
    name: 'Promotions',
    icon: '/img/sidebar/mike.png',
    icon_active: '/img/white/mike.png',
    component: Promotions,
    layout: '/store'
  },
  {
    path: '/guestbook',
    name: 'Guest Book',
    icon: '/img/sidebar/spoon.png',
    icon_active: '/img/white/spoon.png',
    component: GuestBook,
    layout: '/store'
  },
  {
    path: '/settings',
    name: 'Store Settings',
    icon: '/img/sidebar/setting.png',
    icon_active: '/img/white/setting.png',
    component: ArticleSettings,
    layout: '/store'
  },
];
export default routes;